/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_SubtitleInputs */

const vi_my_weighings_subtitle = /** @type {(inputs: My_Weighings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các phiếu cân chè tươi HTX đã ghi cho hộ của bạn.`)
};

/**

* @param {My_Weighings_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_subtitle = /** @type {((inputs?: My_Weighings_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_subtitle(inputs)
});